import { useMutation, UseMutationResult } from "react-query";

import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";

export function useEventRegistrationMutation(): UseMutationResult<any, Error, any> {
  return useMutation((payload) =>
    httpClient.post(ApiRoutes.EventRegister, { data: payload }).then(({ data }) => data),
  );
}
